// extracted by mini-css-extract-plugin
module.exports = {"container":"warning-modal__container--2whLg"};